/**
 * Share API — create and retrieve shareable exploration links.
 */

import { apiClient } from "./client";

export interface ShareConfig {
  share_id: string;
  config: Record<string, unknown>;
}

/**
 * Capture the current project view state into a shareable link.
 * The config object should contain project_id plus any URL search params
 * (branch, nodes, panel, tab, filters, etc.).
 */
export async function createShareLink(
  config: Record<string, unknown>,
): Promise<{ url: string; share_id: string }> {
  return apiClient<{ url: string; share_id: string }>("/share", {
    method: "POST",
    body: config,
  });
}

export async function fetchSharedView(shareId: string): Promise<ShareConfig> {
  return apiClient<ShareConfig>(`/share/${shareId}`);
}
